import React, { useEffect, useState } from 'react'
import DynamicForm from '../../../../customformComponent/customForm/DynamicForm';
import axiosInstance from '../../../../services/api/API';
import { useLocation } from 'react-router-dom';

const SparePart = ({PhysicalStockinId,vendorId,fetchDepartments=()=>{},isEdit,phyItemId,toggleDrawer=()=>{} ,formData,setFormData, businessPartnerIdState}) => {
 
    const [validationErrors, setValidationErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [ userTypedd, setUserTypedd ] = useState([])
    const [ logisticsVariant, setLogisticsVariant ] = useState([])
    const [sparePartOptions,setSparePartOptions]= useState([])
    const [sparePartDetails,setSparePartDetails]=useState([])
    const [ variantDetails, setVariantDetails ] = useState({})
    const [ totalPrice, setTotalPrice ] = useState(0)
    const [ unit, setUnit ] = useState([])
    const userType = localStorage.getItem("UserType")
    const [variantId,setVariantId]= useState(0)
    const businessPartnerId = localStorage.getItem("business_partner_id")
    const token = localStorage.getItem("authToken");
      console.log("vendorId",vendorId);
      
      useEffect(() => {
        const variantId = formData?.variant;
       console.log("formData",formData);
       
        if (variantId) { // Ensure variantId is not undefined or null
          console.log(variantId, 'VariantId', formData);
          fetchVariantDD(variantId);
        }
      }, [formData?.variant]);
      const location = useLocation()
      console.log("isEdit",isEdit);
      
      const StockItemId=location?.state?.data?.phystkin_item_id
      const business_partner_id=location?.state?.data?.business_partner_id
    
      const fetchVariantDD = async (variantId) => {
        try{
          const response = await axiosInstance.post("/variant/ddlvariantbasedetails",{
            variant_id:variantId
          },{
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          })
    
          const fetchedData = response?.data?.data?.data[0]
          console.log(fetchedData, "FETCHEDDATAAAAAA")

          setFormData({
            ...formData,
            make_name: fetchedData.make_name,
            make_id:fetchedData?.make_id,
            model_id:fetchedData?.model_id,
            model_name: fetchedData.model_name,
            product_name: fetchedData.product_name,
            product_id: fetchedData.product_id,
            subproduct_name: fetchedData.subproduct_name,
            subproduct_id: fetchedData.subproduct_id,
            
          })
          setVariantDetails(fetchedData)

          const totalPriceData = response?.data?.data?.data[0]?.purchase_price
          setTotalPrice(totalPriceData)
          console.log(totalPriceData, "TOTALpRICEDATA")
    
        }catch(error){
          console.log(error, "error")
        }
      }
      useEffect(() => {
        userTypedropdown()
      },[])
      
      const userTypedropdown = async () => {
        try{
          const response = await axiosInstance.get("/bp-onboard/bplist",{
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          })
      
          const data = response.data.data.data
          const userTypeOptions = data.map(user => ({
            value: user.onboard_id,
            label:user.bp_name,
          }))
          setUserTypedd(userTypeOptions)
        }catch(error) {
          console.log(error)
        }
      }
    const handleFormSubmit = async (formData) => {
      const errors = {};
      let isValid = true;
  
      VehicleInputs.forEach((field) => {
        if (field.validation && field.validation.required) {
          if (!formData[field.name]) {
            errors[field.name] = "This field is required";
            isValid = false;
          }else if (field.required && field.validation && field.validation.pattern && !field.validation.pattern.test(formData[field.name])) {
            errors[field.name] = field.validation.message;
            isValid = false;
          }
        }
      });
  
      if (!isValid) {
        setValidationErrors(errors);
        return;
      }
      setIsLoading(true);
      console.log("formData",formData,isEdit);

      try {
        if(isEdit){
          const payload = {
            phystkin_id:PhysicalStockinId,
            product_id:formData?.product_id,
            subproduct_id:formData?.subproduct_id,
            variant_id:formData?.variant,
            itemtype:"S",
            itemtype_id:1,
            item_id:formData?.spare_parts,  //// OTHER THEN   "itemtype":"V", Item_id is required
            unitid:sparePartDetails?.unit_id,
            rate:formData?.purchase_price,
            total_price:String(formData?.total),
            good_qty:formData?.goods_quantity,
            business_partner_id: businessPartnerIdState
              }
        
              // if (userType === "superadmin") {
              //   payload.business_partner_id = formData.business_partner_id;
              // } else {
              //   payload.business_partner_id = businessPartnerId;
              // }
        
              const response = await axiosInstance.patch(`/physicalstocktakeitem/update/${phyItemId}`, payload,
              {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${token}`,
                }
              }
            );
          
              console.log("Unit added successfully:", response.data);
              fetchDepartments();
              toggleDrawer();
        }
        else{ const payload = {
          phystkin_id:PhysicalStockinId,
          product_id:formData?.product_id,
          subproduct_id:formData?.subproduct_id,
          variant_id:formData?.variant,
          itemtype:"S",
          itemtype_id:1,
          item_id:formData?.spare_parts,  //// OTHER THEN   "itemtype":"V", Item_id is required
         // unitid:formData?.unit,
          rate:formData?.purchase_price,
          total_price:String(formData?.total),
          good_qty:formData?.goods_quantity,
          unitid:sparePartDetails?.unit_id,
          business_partner_id: businessPartnerIdState
            }
      
            // if (userType === "superadmin") {
            //   payload.business_partner_id = formData.business_partner_id;
            // } else {
            //   payload.business_partner_id = businessPartnerId;
            // }
      
            const response = await axiosInstance.post('/physicalstocktakeitem/create', payload,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              }
            }
          );
        
            console.log("Unit added successfully:", response.data);
            fetchDepartments();
            toggleDrawer()
            }
     
        //navigate('/logistics/manage-stock/physical-stock-taking'); 
      } catch (error) {
        console.error('Error adding data:', error);
  
        console.error("Error submitting form:", error);
      } finally {
        setIsLoading(false);
      }
      console.log("clicked")
    };

    const VehicleInputs = [
      // ...(userType === "superadmin"
      //   ? [
      //       {
      //         name: "business_partner_id",
      //         label: "Business Partner",
      //         type: "dropdown",
      //         required: true,
      //         options: userTypedd,
      //         gridClass: "col-lg-10",
      //         validation: {
      //           required: true,
      //           pattern: /^[A-Za-z0-9 ]*$/,
      //           message: "Only alphabets and digits are allowed",
      //         },
      //       },
      //     ]
      //   : []),
        {
          name: "variant",
          label: "Variant",
          type: "dropdown",
          required: true,
          placeholder:"Select Variant",
          // disabled: fieldsdisabled,
          options:logisticsVariant,
    
          gridClass: "col-lg-10",
        },
        {
          name: "make_name",
          label: "Make",
          type: "text",
          placeholder:"Select Make",
          // options: logisticComapanies,
          // disabled: fieldsdisabled,
          validation: { required: true },
          required: true,
          gridClass: "col-lg-10",
        },
        {
          name: "model_name",
          label: "Model",
          type: "text",
          placeholder:"Select Model",
          // options: logisticComapanies,
          // disabled: fieldsdisabled,
          validation: { required: true },
          required: true,
          gridClass: "col-lg-10",
        },
        {
          name: "product_name",
          label: "Product",
          type: "text",
          placeholder:"Select Product",
          // options: logisticComapanies,
          // disabled: fieldsdisabled,
          validation: { required: true },
          required: true,
          gridClass: "col-lg-6",
        },
        {
          name: "subproduct_name",
          label: "SubProduct",
          type: "text",
          placeholder:"Select Subproduct",
          // options: logisticComapanies,
          // disabled: fieldsdisabled,
          validation: { required: true },
          required: true,
          gridClass: "col-lg-6",
        },
        {
          name: "spare_parts",
          label: "Spare Parts",
          type: "dropdown",
          options:sparePartOptions,
          required: true,
          validation:{required:true},
          gridClass: "col-lg-6",
        },
        {
          name: "unit",
          label: "Unit",
          placeholder:"Select Unit",
          type: "text",
         
          // disabled: fieldsdisabled,
          validation: { required: true },
          required: true,
          gridClass: "col-lg-6",
        },
       
        {
          name: "goods_quantity",
          label: "Goods Quantity",
          placeholder:"Select Goods Quantity",
          type: "text",
          validation: { required: true },
          required: true,
          gridClass: "col-lg-6",
        },
        {
          name: "purchase_price",
          label: "Price",
          type: "text",
          validation: { required: true },
          required: true,
          gridClass: "col-lg-6",
        },
        {
          name: "total",
          label: "Total",
          type: "text",
          validation: { required: true },
          required: true,
          gridClass: "col-lg-12",
        },
    ]
    useEffect(() => {
      fetchLogisticsBaseVariant()
    
     
  },[])

    const fetchLogisticsBaseVariant = async () => {
      try {
        const response = await axiosInstance.post('/physicalstocktakeitem/ddllogisticbasevariant', {
          vendor_id: vendorId,
          business_partner_id:business_partner_id,
          itemtype:"S",
        }, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          }
        });
  
        const formattedData = response?.data?.data?.data
        console.log(formattedData, "VARIANTDATA")
  
        const variantData = formattedData.map(data => ({
          value:data.ID,
          label:data.NAME
        }))
  
        setLogisticsVariant(variantData)
        console.log(logisticsVariant, "LOGISTICSVARIANTID")
  
        console.log("response",response); 
      } catch (error) {
        console.error('Error fetching department list:', error);
      }
    };

    useEffect (()=>{
      if(formData?.variant){
        const fetchSparePartOptions = async() => {
          try {
          const sparepartResponse = await axiosInstance.post('/physicalstocktakeitem/ddllogisticbaseitem', {vendor_id:vendorId,
      itemtype:"S",
      variant_id:formData?.variant,
    business_partner_id:businessPartnerIdState }, {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          });
          const spareOptions = sparepartResponse.data.data.data?.map(product => ({
            label:product.NAME,
            value: product.ID,
          }));
          setSparePartOptions(spareOptions);
        } catch (error) {
          console.log(error);
          
          
        }
      }
      fetchSparePartOptions()
      }
    },[formData?.variant])
    useEffect(() => {
      
     console.log("formData",formData);
     
      if (formData?.spare_parts) { // Ensure variantId is not undefined or null
       
        fetchSparePartDetails(formData?.spare_parts);
      }
    }, [formData?.spare_parts]);

    
        const fetchSparePartDetails = async () => {
          try {
            const token = localStorage.getItem("authToken");
            
            const response = await axiosInstance.post('/item/ddllogisticitembase', {
            stock_type:"S",// for Spare-Parts//2 for accessory
            business_partner_id: businessPartnerIdState,
            item_id:formData?.spare_parts,
            vendor_id:vendorId
            }, {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
            });
                const sparepartdetails = response?.data?.data?.data[0]

            setSparePartDetails(sparepartdetails)
            console.log("sparePartDetails",sparepartdetails);
            
        setFormData({
          ...formData,
          unit:sparepartdetails?.unit,
          unitid:sparepartdetails?.unit_id,
          purchase_price:sparepartdetails?.purchase_price,  
        
        })
          } catch (error) {
            console.error("Error fetching variant options:", error);
          }
        };
 

    // useEffect(() => {
    //   unitDD()
    // },[])

    // const unitDD = async () => {
    //   try {
    //     const response = await axiosInstance.post('/unit/ddlunit', {
    //       business_partner_id: 1
    //     }, {
    //       headers: {
    //         "Content-Type": "application/json",
    //         Authorization: `Bearer ${token}`,
    //       }
    //     });
  
    //     const formattedData = response?.data?.data?.data
    //     console.log(formattedData, "VARIANTDATA")
  
    //     const unitData = formattedData.map(data => ({
    //       value:data.ID,
    //       label:data.NAME
    //     }))
  
    //     setUnit(unitData)

  
    //     console.log("response",response); 
    //   } catch (error) {
    //     console.error('Error fetching department list:', error);
    //   }
    // };
    useEffect(() => {
      const fetchSparePartExistingDetails = async () => {
        console.log("api called");
        
        try {
          const response = await axiosInstance.get(`/physicalstocktakeitem/edit/${phyItemId}`, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
    
          if (response.status === 200) {

            const vehicleData = response.data.data[0];
            console.log("vehicledata",vehicleData,response);
            
        
    
            const transformedData = {
              business_partner_id:vehicleData?.business_partner_id,
              productname: vehicleData.product_name,
              variant: vehicleData.variant_id,
             
              goods_quantity:vehicleData?.good_qty,
              spare_parts: vehicleData?.item_id,
              total:String(vehicleData?.total_price)
             
            };
    
            setFormData(transformedData); 
            fetchVariantDD(vehicleData.variant_id)
            fetchSparePartDetails(vehicleData?.spare_parts)          
            console.log("Transformed vehicle data set to formData:", transformedData);
          } else {
            console.error('Failed to fetch vehicle data');
          }
        } catch (error) {
          console.error('Error fetching vehicle data:', error);
        }
      };
    
      if (isEdit) {
     
        fetchSparePartExistingDetails();
      }
    }, [isEdit]);
    

  return (
    <div>
        <DynamicForm
          formConfig={VehicleInputs}
          formData={formData}
          setFormData={setFormData}
          onSubmit={handleFormSubmit}
          validationErrors={validationErrors}
          setValidationErrors={setValidationErrors}
        />
            <button 
            onClick={() => {handleFormSubmit(formData)}}
            className="submit-btn"
            style={{marginTop:"15px", width:"85%"}}
            >
            Submit
            </button>
        </div>
  )
}

export default SparePart;